// Self-hosted (font-src 'self'): only the latin subset in the weights used. Keys must match ThemeService.FONTS.
import '@fontsource/nunito/latin-400.css';
import '@fontsource/nunito/latin-700.css';
import '@fontsource/nunito/latin-800.css';
import '@fontsource/cormorant-garamond/latin-400.css';
import '@fontsource/cormorant-garamond/latin-700.css';
import '@fontsource/playfair-display/latin-400.css';
import '@fontsource/playfair-display/latin-700.css';
import '@fontsource/eb-garamond/latin-400.css';
import '@fontsource/eb-garamond/latin-700.css';
import '@fontsource/lora/latin-400.css';
import '@fontsource/lora/latin-700.css';
import '@fontsource/source-sans-3/latin-400.css';
import '@fontsource/source-sans-3/latin-700.css';
import '@fontsource/fredoka/latin-400.css';
import '@fontsource/fredoka/latin-600.css';
import '@fontsource/caveat/latin-400.css';
import '@fontsource/caveat/latin-700.css';

export type FontOption = { key: string; label: string; stack: string };

export const FONT_OPTIONS: FontOption[] = [
  { key: 'nunito', label: 'Nunito (rond)', stack: "'Nunito', ui-rounded, system-ui, sans-serif" },
  { key: 'source-sans-3', label: 'Source Sans 3', stack: "'Source Sans 3', system-ui, sans-serif" },
  { key: 'fredoka', label: 'Fredoka (afgerond)', stack: "'Fredoka', ui-rounded, system-ui, sans-serif" },
  { key: 'caveat', label: 'Caveat (krijtschrift)', stack: "'Caveat', 'Segoe Script', cursive" },
  { key: 'lora', label: 'Lora', stack: "'Lora', Georgia, serif" },
  { key: 'eb-garamond', label: 'EB Garamond', stack: "'EB Garamond', Georgia, serif" },
  { key: 'cormorant-garamond', label: 'Cormorant Garamond', stack: "'Cormorant Garamond', Georgia, serif" },
  { key: 'playfair-display', label: 'Playfair Display', stack: "'Playfair Display', Georgia, serif" },
];

export function fontStack(key: string): string {
  return FONT_OPTIONS.find((font) => font.key === key)?.stack ?? FONT_OPTIONS[0]?.stack ?? 'sans-serif';
}
